/* import __COLOCATED_TEMPLATE__ from './output-signal-options.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type CircuitService from '../services/circuit';
import type DisplayOptionsService from '../services/display-options';
import type SiteService from '@ebiz/ember-aditools-site/services/aditools-site';

const HARMONIC_LEVEL_MAX = 0,
  HARMONIC_LEVEL_MIN = -120;

interface OutputSignalOptionsSignature {
  Element: HTMLDivElement;
}
/**
 * The main panel of the application
 *
 * @extends {Component<OutputSignalOptionsSignature>}
 */
export default class OutputSignalOptionsPanel extends Component<OutputSignalOptionsSignature> {
  @service declare displayOptions: DisplayOptionsService;
  @service declare circuit: CircuitService;
  @service('aditools-site') declare siteconfig: SiteService;

  @action harmonicLevelChanged(event: Event) {
    const harmonicsSpurLevel = this.displayOptions.harmonicDB;
    if (event.target && event.target instanceof HTMLInputElement) {
      if (isNaN(Number(event.target.value)) || harmonicsSpurLevel !== Number(event.target.value)) {
        let result = isNaN(Number(event.target.value)) ? harmonicsSpurLevel : Number(event.target.value);
        if (result > HARMONIC_LEVEL_MAX) {
          result = HARMONIC_LEVEL_MAX;
        } else if (result < HARMONIC_LEVEL_MIN) {
          result = HARMONIC_LEVEL_MIN;
        }
        this.displayOptions.harmonicDB = result;
      }
    }
  }

  @action fundamentalFilterChanged(value: boolean) {
    this.displayOptions.fundamentalFilter = value;
  }

  @action dacImagesFilterChanged(value: boolean) {
    this.displayOptions.dacImagesFilter = value;
  }

  @action pptSpurFilterChanged(value: boolean) {
    this.displayOptions.pptSpurFilter = value;
  }

  @action harmonicsFilterChanged(value: boolean) {
    this.displayOptions.harmonicsFilter = value;
  }

  @action harmonics2FilterChanged(value: boolean) {
    this.displayOptions.harmonics2Filter = value;
  }

  @action harmonics3FilterChanged(value: boolean) {
    this.displayOptions.harmonics3Filter = value;
  }
}
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    OutputSignalOptions: typeof OutputSignalOptionsPanel;
  }
}
